import { render, staticRenderFns } from "./ViewProjectButton.vue?vue&type=template&id=96321710&"
import script from "./ViewProjectButton.vue?vue&type=script&lang=js&"
export * from "./ViewProjectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports